import * as types from './mutation_types'
import { filter } from 'lodash'

export default {
  [types.THUMBNAIL_LIST_RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      view: {},
      totalItems: 0
    })
  },

  [types.THUMBNAIL_LIST_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.THUMBNAIL_LIST_SET_LOADING] (state, isLoading) {
    Object.assign(state, { isLoading })
  },

  [types.THUMBNAIL_LIST_SET_ITEMS] (state, { items, created, deleted }) {
    if (created) {
      state.items = [...state.items, created]
    } else if (deleted) {
      state.items = filter(state.items, (item) => item['@id'] !== deleted)
    } else {
      Object.assign(state, { items })
    }
  },

  [types.THUMBNAIL_LIST_SET_VIEW] (state, view) {
    Object.assign(state, { view })
  },

  [types.THUMBNAIL_LIST_SET_TOTAL_ITEMS] (state, totalItems) {
    Object.assign(state, { totalItems })
  }
}
